var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rolePower)?_c('div',{staticClass:"growth-journey"},[_c('TitleBar',{staticClass:"title-bar-view",attrs:{"title":'成长旅程',"showAll":false}}),_vm._v(" "),(_vm.rolePower)?_c('GrowthJourneyPage',{ref:"growthJourney"}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a0c0ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GrowthJourney.vue
// module id = null
// module chunks = 